import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "info-text"
}
const _hoisted_2 = {
  key: 0,
  class: "info-text__title"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'info-text',
  props: {
    title: {},
    perex: {},
    showBackLink: { type: Boolean }
  },
  emits: ["prevStep"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const goBack = () => {
    emit("prevStep");
};

return (_ctx: any,_cache: any) => {
  return (_ctx.title || _ctx.perex)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_2, [
              (_ctx.showBackLink)
                ? (_openBlock(), _createBlock(DsIcon, {
                    key: 0,
                    class: "info-text__title-arrow",
                    width: 22,
                    height: 22,
                    name: "arrow-right",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack()))
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: "info-text__title-text",
                innerHTML: _ctx.title
              }, null, 8, _hoisted_3)
            ]))
          : _createCommentVNode("", true),
        (_ctx.perex)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "info-text__perex",
              innerHTML: _ctx.perex
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})